import { isEmpty } from '@app/utils/isEmpty';
import { Order, Payments } from '@typings';
import { useTranslation } from 'react-i18next';

export const usePaymentMethodsByMode = (
  paymentTerm: Maybe<Order.PaymentTerm>,
  orderPaymentMethods: Payments.PaymentMethod[],
): Payments.PaymentMethod[] => {
  const paymentMode = paymentTerm?.paymentMode ?? 'disabled';
  const { t } = useTranslation(['payments']);
  if (paymentMode === 'disabled' || isEmpty(orderPaymentMethods)) {
    return [];
  }

  if (paymentMode === 'required') {
    return orderPaymentMethods;
  }

  return [
    {
      description: t('payments:pay_later_description', { count: paymentTerm?.dueDays }),
      name: t('payments:pay_later'),
      paymentMethod: 'pay_later',
      paymentMethodType: 'pay_later',
    },
    ...orderPaymentMethods.map(paymentMethod => {
      if (paymentMethod.paymentMethodType === 'stripe_checkout' || paymentMethod.paymentMethodType === 'stripe_checkout_wholesale') {
        return { ...paymentMethod, description: t('payments:powered_by_stripe') };
      }

      if (paymentMethod.paymentMethodType === 'paypal_wholesale') {
        return { ...paymentMethod, description: t('payments:powered_by_paypal') };
      }

      return paymentMethod;
    }),
  ];
};
